import React, { useState } from 'react'
import DashboardHeader from '../../../components/dashboardheader/DashboardHeader';
import CancelButton from '../../../components/buttons/cancelbutton/CancelButton';
import { useOutletContext } from 'react-router-dom';
import ComponentTabs from '../../../components/tabcomponent/TabComponent';
import MasterColonyList from './MasterColonyList';
import "./MasterColonyPage.scss"
import MasterPendingColonies from './MasterPendingColonies';

function MasterColonyPage() {
    const {toggleMenu} = useOutletContext(); // get the toggleMenu function
    const [activeTab, setActiveTab] = useState(0);

    const tabItems = [
        { label: "Colonies", content: <MasterColonyList/> },
        {
        label: "Pending Requests",
        content: <MasterPendingColonies/>,
        },
    ];


 
    return (
        <>
            <div className="masterColonyPage">
                <div className="PageHeader">
                    {/* Admin Data Test Page */}
                    <DashboardHeader
                        title="Master Colonies "
                        toggleMenu={toggleMenu}
                        variant="admin"
                    ></DashboardHeader>
                    {/* <h1 className="formTitle">Admin Data Test Page</h1>           */}
                </div>
                <div className="tabContainer">
                    {/* <h1>Load Image, Crop, Copy, Paste and Save to Database</h1> */}

                    <ComponentTabs
                        tabs={tabItems}
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />

                
                </div>



            <CancelButton></CancelButton>
            </div>

        
        
        </>

  )
}

export default MasterColonyPage
